import { useQuery } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

export default function useMyPersonalDataQuery(userLogged: boolean) {
  
  const { shopLang, shopMarketId } = useShop();

  const getCustomerData = async () => {
    return await OpenapiSingleton.BuyerPersonalDataAPIApi.get1(
      shopMarketId,
      shopLang,
    );
  };

  return useQuery({
    queryKey: ["getCustomerData"],
    queryFn: getCustomerData,
    enabled: userLogged,
    retry: false,
  });
}